import { LoadingSvg } from "@lyteflo/components";

export const PageLoader = () => (
  <div className="lf-flex lf-justify-center lf-items-center lf-py-20">
    <LoadingSvg className="lf-size-10 lf-animate-spin" />
  </div>
);
